import "./Card.css";
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
function Card({ product }) {
  const { name, category, image, subcategory } = product;
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>

      <Link to={`/productos/${product.subcategory}/${product.name}`} className="card-container">
        <img id={"image-" + product.id} src={image} className="product-image" alt={name} loading="lazy" />
        <div className="card-text-button">
          <div className="card-text">
            <p className="product-category">{subcategory && category.toUpperCase() + " " + subcategory.toUpperCase()}</p>
            <p className="product-name">{name}</p>
          </div>
        </div>
      </Link>

    </>
  )
};

export default Card;
